import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type { ICollectionStatusResponse } from "@/types/response";

class DashboardService extends BaseHttp {
  async getCollectionStatus(year: number) {
    const { data } = await this.get<ICollectionStatusResponse>(
      "/collection-status",
      { year },
      { requestKey: "getCollectionStatus" }
    );
    return data;
  }
}

export default new DashboardService(apiGwClient, "/api/v1/dashboards");
